module.exports = __webpack_public_path__ + "img/fanglz_top.7d5009f8.png";